(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentPlans', {
        templateUrl: 'views/components/views/consignmentPlans/consignmentPlans.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'translateService', 'modalService', 'consignmentPlansService', 'rememberService', function (stateService, utilityService, translateService, modalService, consignmentPlansService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let reload;
            var editing = false;

            let variableNames = {
                date_fom: '',
                date_tom: '',
                dateselector_index: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                bgJobStatus: {
                    selected: 'consignmentplans_now',
                    buttons: [
                        { id: 'consignmentplans_now', label: 'consignmentplans_now', color: 'primary', onClick: () => vm.model.bgJobStatus.selected = 'consignmentplans_now' },
                        { id: 'consignmentplans_not_finished', label: 'consignmentplans_not_finished', color: 'primary', onClick: () => vm.model.bgJobStatus.selected = 'consignmentplans_not_finished' },
                        { id: 'consignmentplans_finished', label: 'consignmentplans_finished', color: 'primary', onClick: () => vm.model.bgJobStatus.selected = 'consignmentplans_finished' }
                    ]
                },
                mconfig: {
                    enabled: true,		// Is the menu button enabled
                    show: false,		// Is the menu visible or not
                    activate: function (item) {
                        if (item === 'all') {
                            vm.model.mconfig.records.forEach((data) => {
                                if (data) {
                                    if (data.canActive === true) {
                                        data.isActive = true;
                                    }
                                }
                            });
                        } else if (item) {
                            vm.model.mconfig.records[item.item_id].isActive = true;
                        } else {
                            vm.model.mconfig.records[0].isActive = true;
                        }
                    },
                    deactivate: function (item) {
                        if (item === 'all') {
                            vm.model.mconfig.records.forEach((data) => {
                                if (data) {
                                    if (data.item_name === 'resize' && data.isActive) {
                                        resizeWidth();
                                    }
                                    if (data.canActive === true) {
                                        data.isActive = false;
                                    }
                                }
                            });
                        } else if (item) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else {
                            vm.model.mconfig.records[0].isActive = false;
                        }
                    },
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                editing = true;
                            } else {
                                resizeWidth();
                            }
                        }
                        if (item.item_name === 'columns') {
                            if (item.isActive) {
                                editing = true;
                            } else {
                                editing = false;
                            }
                        }
                    },
                    records: [
                        { item_id: '0', item_name: 'sort', glyph: 'glyphicon-sort', color: 'primary', canActive: true, isActive: false, colorActive: 'warning', isIcon: false, enabled: true, show: true },
                        { item_id: '1', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', canActive: true, isActive: false, colorActive: 'warning', isIcon: false, enabled: true, show: true },
                        { item_id: '2', item_name: 'columns', glyph: 'fa-columns', color: 'primary', canActive: true, isActive: false, colorActive: 'warning', isIcon: false, enabled: true, show: true },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                setting: {},
                itemsListPlans: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await consignmentPlansService.getSetting())[0];

                return Promise.all([
                    loadPlans()
                ]);
            }

            async function loadPlans() {
                if (utilityService.validateParmsValue(vm.model.bgJobStatus.selected) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;

                vm.model.itemsListPlans = await consignmentPlansService.listPlans({
                    consignment_plan_status: vm.model.bgJobStatus.selected,
                    view_id: 'w_' + stateService.getCurrentName() + '.' + vm.model.bgJobStatus.selected,
                    date_fom: vm.model.setting.date_fom,
                    date_tom: vm.model.setting.date_tom
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'date_fom':
                    case 'date_tom':
                    case 'dateselector_index':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgJobStatus = function (value) {
                vm.model.bgJobStatus.selected = value;
                loadPlans();
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region DRAG AND DROP SORT FUNCTION

            vm.reorderPlans = function () {
                for (let m = 0; m < vm.model.mconfig.records.length; m++) {
                    if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                        vm.model.mconfig.records[m].animate = true;
                        break;
                    }
                }
                
                for (let a = 0; a < vm.model.mconfig.records.length; a++) {
                    if (vm.model.mconfig.records[a] && vm.model.mconfig.records[a].item_id === '99') {
                        vm.model.mconfig.records[a].animate = false;
                        break;
                    }
                }

                setTimeout(() => vm.model.mconfig.records[a].animate = null, 2000);
            };

            // #endregion DRAG AND DROP SORT FUNCTION

            // #region RESIZE COLUMN WIDTH FUNCTION PROCEDURE CALL

            function resizeWidth() {
                for (let m = 0; m < vm.model.mconfig.records.length; m++) {
                    if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                        vm.model.mconfig.records[m].animate = true;
                        break;
                    }
                }

                let updateList = [];

                if (vm.model.itemsListPlans[0] && vm.model.itemsListPlans[0].item_secondary) {
                    for (let r = 0; r < vm.model.itemsListPlans[0].item_secondary.length; r++) {
                        if (r === 0) {
                            updateList.push({ item_id: r, item_col_width: vm.model.itemsListPlans[0].item_col_width })
                        }

                        if (vm.model.itemsListPlans[0].item_secondary[r]) {
                            updateList.push({ item_id: r + 1, item_col_width: vm.model.itemsListPlans[0].item_secondary[r].item_col_width })
                        }
                    }
                }

                consignmentPlansService.updateWidth({
                    view_id: 'w_' + stateService.getCurrentName() + '.' + vm.model.bgJobStatus.selected,
                    records: updateList
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                }
                            }]
                        });
                    } else {
                        for (let m = 0; m < vm.model.mconfig.records.length; m++) {
                            if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                                vm.model.mconfig.records[m].animate = false;
                                break;
                            }
                        }

                        setTimeout(() => vm.model.mconfig.records[m].animate = null, 2000);
                    }

                    editing = false;
                });
            }

            // #endregion RESIZE COLUMN WIDTH FUNCTION PROCEDURE CALL

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'consignmentplan':
                    case 'consignmentplanbuild':
                        go({ custact_no: '0' });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region FIELD DATE RANGE CHANGE FUNCTION

            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                vm.model.setting.date_fom = startDate;
                vm.model.setting.date_tom = endDate;
                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

                if (vm.model.setting.date_fom) rememberFunc('date_fom');
                if (vm.model.setting.date_tom) rememberFunc('date_tom');
                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
                    loadPlans();
                }
            };

            // #endregion FIELD DATE RANGE CHANGE FUNCTION

            // #region RELOAD INTERVAL FUNCTION

            function reloadInterval() {
                consignmentPlansService.reloadPlans();

                if (!editing) {
                    loadPlans();
                }
            }

            // #endregion RELOAD INTERVAL FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
                reload = setInterval(reloadInterval, 15000);
            }

            // #endregion ON INIT FUNCTION

            // #region ON DESTROY FUNCTION

            vm.$onDestroy = function () {
                clearInterval(reload);
            }

            // #endregion ON DESTROY FUNCTION

        }]
    });
})();
